import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = ({ user, scrollToTop }) => {
  if (!user) return <Navigate to="/login" />;
  return (
    <>
      {scrollToTop}
      <Outlet />
    </>
  );
};

export default ProtectedRoutes;
